import React, { useState } from "react";
import { Form, Button, Card, Container, Row, Col, Alert, NavbarBrand } from "react-bootstrap";
import { setAuthToken, setUsername } from "../../utils/auth";

function Login() {


    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Email:", email);
        console.log("Password:", password);


        setErrorMsg("");
        setSuccessMsg("");
        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, password })
            });
            const data = await response.json();
            if (data.status === true) {
                const token = data.data.token;
                setAuthToken(token)
                setUsername(email)
                setSuccessMsg("Login successful! Redirecting...");
                setTimeout(() => {
                    window.location.href = "/admin";
                }, 300);
            } else {
                setErrorMsg(
                    data.apiError?.businessErrorDescription || data.message || "Login failed"
                );
            }
        } catch (error) {
            setErrorMsg("Network error. Please try again.");
        } finally {
            setLoading(false);
        }

    };

    return (
        <Container fluid className="d-flex justify-content-center align-items-center vh-100 bg-body-tertiary">
            <Row className="w-100 justify-content-center">
                <Col md={4}>
                    <Card className="shadow p-4">
                        <Card.Body>

                            <NavbarBrand href="/" className="fs-4 mb-4">KarmanTrener <span className="text-body-emphasis" >.COM</span> </NavbarBrand>

                            <h3 className="text-center mb-4 fw-bold mt-4">Login</h3>

                            {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
                            {successMsg && <Alert variant="success">{successMsg}</Alert>}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3 text-start" >
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3 text-start">
                                    <Form.Label >Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Button disabled={loading}
                                    variant="primary"
                                    type="submit"
                                    className="w-100 py-2 fw-semibold"
                                >
                                    {loading ? "Checking credentials..." : "Login"}
                                </Button>


                                <div className="text-center mt-3">
                                    <a href="/register">Not registered yet? Register now</a>
                                </div>

                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;
